import styles from './kycHub.module.scss';

/** A brand-coloured on/off filter, in place of antd's blue checkbox. */
export const TogglePill = ({active, onChange, children}) => (
  <button
    type="button"
    aria-pressed={active}
    className={active ? styles.pillActive : styles.pill}
    onClick={() => onChange(!active)}>
    {active ? '✓ ' : ''}
    {children}
  </button>
);
